import { isToday, isYesterday, formatDate, ImageFormat, getFeatureEnabled, RoutablePage, cdnService, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { MessageStatus, MessagePriority } from '@gig/magic-sdk/dist/adapter/messages/message';
import { magic } from '@gig/magic-sdk';
import { isResponsibleGamingAlert } from '../../util/messages.js';
import '../../util/dom.js';
import { Feature, IS_MOBILE_APP_QUERY, MOBILE_APP_MESSAGE_MARK_AS_READ } from '@gig/magic-messages';

var MessageComponent = /** @class */ (function (_super) {
    __extends(MessageComponent, _super);
    function MessageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showMessageImage = false;
        _this.showMessageVideo = false;
        _this.isMobileApp = false;
        _this.isArchiving = false;
        return _this;
    }
    Object.defineProperty(MessageComponent.prototype, "isNew", {
        get: function () {
            return this.message.status === MessageStatus.NEW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "isRead", {
        get: function () {
            return this.message.status === MessageStatus.READ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "readButtonText", {
        get: function () {
            return this.message.status === MessageStatus.READ
                ? this.$t('message.read-again.button')
                : this.$t('message.read.button');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "sentDate", {
        get: function () {
            if (!this.message) {
                return '';
            }
            var messageSentDate = new Date(this.message.sentAt) || new Date(this.message.created);
            if (isToday(messageSentDate)) {
                return this.$t('message.today');
            }
            if (isYesterday(messageSentDate)) {
                return this.$t('message.yesterday');
            }
            return formatDate(this.message.created);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageSubject", {
        get: function () {
            return this.getMessageValue('subject', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageBody", {
        get: function () {
            return this.getMessageValue('body', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageTNC", {
        get: function () {
            return this.getMessageValue('tnc', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageLink", {
        get: function () {
            return this.getMessageValue('link', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageURL", {
        get: function () {
            return this.getMessageValue('url', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageLink2", {
        get: function () {
            return this.getMessageValue('link2', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "messageURL2", {
        get: function () {
            return this.getMessageValue('url2', this.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "src", {
        get: function () {
            return this.getImage(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "avifSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.AVIF);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "webpSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "shouldShowMessageImage", {
        get: function () {
            return this.showMessageImage && !this.summary && this.src;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "shouldShowMessageVideo", {
        get: function () {
            return this.showMessageVideo && !this.summary && this.videoSrc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageComponent.prototype, "videoSrc", {
        get: function () {
            return this.getVideo();
        },
        enumerable: false,
        configurable: true
    });
    MessageComponent.prototype.getMessageValue = function (key, message) {
        return message ? message[key] : '';
    };
    MessageComponent.prototype.isGamingAlert = function () {
        return this.message ? isResponsibleGamingAlert(this.message) : false;
    };
    Object.defineProperty(MessageComponent.prototype, "videoElement", {
        get: function () {
            return this.$refs.videoPlayer;
        },
        enumerable: false,
        configurable: true
    });
    MessageComponent.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, window.queryBus.query(IS_MOBILE_APP_QUERY)];
                    case 1:
                        _b.isMobileApp =
                            (_a = (_e.sent())) !== null && _a !== void 0 ? _a : false;
                        _c = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.DISPLAY_MESSAGE_IMAGE)];
                    case 2:
                        _c.showMessageImage = _e.sent();
                        _d = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.VIDEOS_ON_MESSAGES)];
                    case 3:
                        _d.showMessageVideo = _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MessageComponent.prototype.mounted = function () {
        var _this = this;
        if (!this.message) {
            this.routeTo({
                route: RoutablePage.MESSAGES,
            });
        }
        if (this.summary) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.message ||
                            this.message.once ||
                            this.isGamingAlert() ||
                            this.message.priority === MessagePriority.POP_OPEN) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.methods.messages.markAsRead(this.message.id)];
                    case 1:
                        _a.sent();
                        if (this.isMobileApp &&
                            this.message.status === MessageStatus.NEW) {
                            window.eventBus.publish(MOBILE_APP_MESSAGE_MARK_AS_READ);
                        }
                        this.messageRead(this.message.id);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // Ignore the error as the user cannot do anything about it
                        // and it's not important (the message it's simply not marked
                        // as read)
                        console.error(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    };
    MessageComponent.prototype.introVideoLoaded = function () {
        this.videoElement.play();
    };
    MessageComponent.prototype.destroyed = function () {
        var _this = this;
        if (this.summary) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.message ||
                            this.message.priority === MessagePriority.POP_OPEN ||
                            this.isGamingAlert() ||
                            !this.message.once) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.methods.messages.archive(this.message.id)];
                    case 1:
                        _a.sent();
                        this.messageRead(this.message.id);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        // Ignore the error as the user cannot do anything about it
                        // and it's not important (the message it's simply not marked
                        // as read)
                        console.error(err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    };
    MessageComponent.prototype.archive = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isArchiving = true;
                        return [4 /*yield*/, magic.methods.messages.archive(this.message.id)];
                    case 1:
                        _a.sent();
                        this.isArchiving = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emitted when acknowledgement button has
     * been pressed.
     */
    MessageComponent.prototype.acknowledge = function () {
        this.messageRead(this.message.id);
        return this.message;
    };
    MessageComponent.prototype.messageRead = function (id) {
        return { id: id, isPopOpen: false };
    };
    MessageComponent.prototype.ctaClicked = function (cta) {
        return cta;
    };
    MessageComponent.prototype.getImageSrcset = function (format) {
        return this.getImage(format) + ", " + this.getImage(format, true) + " 2x";
    };
    MessageComponent.prototype.getImage = function (format, retina) {
        if (retina === void 0) { retina = false; }
        if (!this.message || !this.message.image) {
            return '';
        }
        return cdnService.getOmsImageUrl(this.message.image, {
            width: this.imageWidth,
            quality: 100,
            retina: retina,
            format: format,
        });
    };
    MessageComponent.prototype.getVideo = function () {
        if (!this.message || !this.message.video) {
            return '';
        }
        var videoUrls = this.message.video;
        var videoUrl = videoUrls !== null && videoUrls !== void 0 ? videoUrls : '';
        return cdnService.getOmsVideoUrl(videoUrl);
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], MessageComponent.prototype, "summary", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], MessageComponent.prototype, "message", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], MessageComponent.prototype, "hideBacklink", void 0);
    __decorate([
        Prop({ type: Number, default: 424 }),
        __metadata("design:type", Number)
    ], MessageComponent.prototype, "imageWidth", void 0);
    __decorate([
        Emit('acknowledged'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MessageComponent.prototype, "acknowledge", null);
    __decorate([
        Emit('message-read'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Object)
    ], MessageComponent.prototype, "messageRead", null);
    __decorate([
        Emit('ctaClicked'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MessageComponent.prototype, "ctaClicked", null);
    MessageComponent = __decorate([
        Component({
            name: 'message',
        })
    ], MessageComponent);
    return MessageComponent;
}(Mixins(MagicConfigMixin)));

export default MessageComponent;
